import { PARTNER_ADMIN_USER_ROLES, XEMEX_STAFF_ROLES } from './device-role-groups.constant';

/** Roles allowed to edit a device's meter role (Settings tab), per TC5-TC9 in
 * teststrategie.md — matches auth.role_feature_setting's setting.meterRole grants
 * (Installer_admin/Subinstaller_admin/Mechanic are excluded there). */
export const METER_ROLE_EDITOR_ROLES: string[] = [...PARTNER_ADMIN_USER_ROLES, ...XEMEX_STAFF_ROLES];
